import Box from '@mui/material/Box'
import { Button, Stack, Typography } from '@mui/material'
import { AssignDiscipline } from '../../models/Review'
import ProgressBarComponent from '../ProgressBarComponent'

interface ManageProjectProps {
  discipline: AssignDiscipline
}

const ManageProjectComponent: React.FC<ManageProjectProps> = ({
  discipline,
}) => {
  return (
    <Stack sx={{ width: '100%', minHeight: '5.8rem' }} gap={'1rem'}>
      <Stack gap='1rem'>
        <ProgressBarComponent completed={74} total={123} height='1.5rem' />
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
          }}
        >
          <Box
            gap='0.5rem'
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifuyContent: 'center',
            }}
          >
            <Box
              sx={{
                width: '10px',
                height: '10px',
                borderRadius: '10px',
                background: '#FF0000',
              }}
            ></Box>
            <Typography
              sx={{
                color: '#04002E',
                fontSize: '0.82rem',
                fontWeight: 500,
                lineHeight: 'normal',
              }}
            >
              6 new alerts
            </Typography>
          </Box>
          <Button
            variant='outlined'
            sx={{
              textTransform: 'capitalize',
              fontSize: '0.64rem',
              borderRadius: '4px',
              background: 'transparent',
              border: '1px solid #56003D',
              color: '#56003D',
              height: '1.5rem',
            }}
          >
            Continue
          </Button>
        </Box>
      </Stack>
    </Stack>
  )
}

export default ManageProjectComponent
